/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from '@angular/core';
import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(ActivityTypeDataService.Id, ActivityTypeDataService);

    ActivityTypeDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class ActivityTypeDataService extends base.BaseDataService<Nema.Crew.Model.ActivityType> implements IActivityTypeDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "activityTypeDataService";

    public get EntityName(): string {
        return "ActivityType";
    }

    public get EntitiesName(): string {
        return "ActivityTypes";
    }
}

export interface IActivityTypeDataService extends base.IDataService<Nema.Crew.Model.ActivityType> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/activitytypes.dataservice.ts